import { render, staticRenderFns } from "./OutStock.vue?vue&type=template&id=b08b72e8&scoped=true&"
import script from "./OutStock.vue?vue&type=script&lang=js&"
export * from "./OutStock.vue?vue&type=script&lang=js&"
import style0 from "./OutStock.vue?vue&type=style&index=0&id=b08b72e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08b72e8",
  null
  
)

export default component.exports